<template>
	<div id="team" class="Team">
		<vue-snotify></vue-snotify>
		<div v-if="!loadingTeam">
			<div v-if="objectTeam.id > 0">
				<div class="row nav nav-tabs">
					<!-- small box -->
					<div class="col-lg-3 col-12">
						<div class="small-box bg-primary">
							<div class="inner pointer text-white" @click="selectTab(1)">
								<h3 style="font-weight: normal;">$ {{ methodFormatNumber(totalOrdersPrice) }}
								</h3>
								<p class="text-white">
									Total <b>$</b> en Pedidos
								</p>
							</div>
							<div class="icon">
								<i class="fas fa-shopping-cart"></i>
							</div>
							<span class="small-box-footer pointer" @click="showOrderColportajeModalComponentLocal()">Nuevo Pedido <i class="fas fa-plus"></i></span>
						</div>
					</div>
					<div class="col-lg-3 col-12">
						<div class="small-box bg-info">
							<div class="inner pointer text-white" @click="selectTab(2)">
								<h3 style="font-weight: normal;">$ {{ methodFormatNumber(totalConsignmentsPrice) }}
								</h3>
								<p class="text-white">
									Total <b>$</b> en Remesas
								</p>
							</div>
							<div class="icon">
								<i class="fas fa-dollar-sign"></i>
							</div>
							<span class="small-box-footer pointer" @click="showConsignmentModalLocal()">Nuevo Pago <i class="fas fa-plus"></i></span>
						</div>
					</div>
				</div>
				<div class="tab-content" id="teamTabContent">
					<div class="tab-pane fade" :class="(tabSelected == 1) ? 'show active' : ''" id="tabOrder" role="tabpanel" aria-labelledby="home-tab">
						<div class="card" style="margin-bottom: 5px; font-weight: bold;" id="id0">
							<div class="card-body" style="padding-top: 5px; padding-bottom: 5px; ">
								<div class="row">
									<div class="col-md-1 text-center">
										ID
									</div>
									<div class="col-md-3 text-center">
										Nombre
									</div>
									<div class="col-md-3 text-center">
										Enviado a
									</div>
									<div class="col-md-2 text-center">
										Fecha
									</div>
									<div class="col-md-1 text-center">
										Monto
									</div>
									<div class="col-md-2 text-center">
										Estado
									</div>
								</div>
							</div>
						</div>
						<div class="card" style="margin-bottom: 5px" :id="'id' + (index + 1)" v-for="(item, index) in listOrders" :key="index" :class="(open != 0) ? 'text-muted' : ''">
							<div class="card-body" :class="(index + 1 == open) ? 'border border-dark rounded' : '' " style="padding-top: 5px; padding-bottom: 5px;">
								<div class="row" v-if="(index + 1 != open)">
									<div class="col-md-1 text-center">
										{{ item.id }}
									</div>
									<div class="col-md-3 text-center">
										{{ item.client }}
									</div>
									<div class="col-md-3 text-center">
										{{ item.sendto[0].sendto }}
									</div>
									<div class="col-md-2 text-center">
										{{ item.created_at }}
									</div>
									<div class="col-md-1 text-right">
										${{ methodFormatNumber(item.total) }}
									</div>
									<div class="col-md-2 text-center" style="padding-right:5px">
										<span class="badge" :class="'badge-' + item.color">{{ item.status }}</span>
										<a :href="'#id' + index" class="fas fa-plus float-right pointer" style="margin-top:4px;" @click="open = (index + 1)" :title="index"></a>
									</div>
								</div>
								<div v-else style="margin-right:-10px; margin-top:10px">
									<div>
										<label>Fecha de creación:</label> {{ item.created_at }}
										<i class="fas fa-minus float-right pointer" style="margin-top:-6px; margin-left:10px;" @click="open = 0"></i>
										<span class="float-right"><label>Estado:</label> <span class="badge" :class="'badge-' + item.color">{{ item.status }}</span></span>
									</div>
									<div class="row">
										<div class="col-md-8">
											<div class="border rounded" style="padding:10px; margin-bottom:3px">
												<div class="row">
													<div class="col-md-8">
														<p><label>Cargado a:</label> {{ item.client }}</p>
														<p><label>Enviar a:</label> {{ item.sendto[0].sendto }}</p>
													</div>
													<div class="col-md-4">
														<p><label>Nº de Pedido:</label> {{ item.id }}</p>
														<p><label>Telefono:</label> {{ item.sendto[0].phone }}</p>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12">
														<p>
															<label>Dirección:</label> {{ item.sendto[0].street }} - {{ item.sendto[0].comuna }}
														</p>
													</div>
												</div>

											</div>
											<table class="table table-sm table-12">
												<thead>
													<tr>
														<th class="text-center">#</th>
														<th class="text-center">Articulo</th>
														<th class="text-center">Cantidad</th>
														<th class="text-center">Precio</th>
														<th class="text-center">Total</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(it, ind) in item.order_products" :key="ind">
														<td class="text-center">{{ ind + 1 }}</td>
														<td>{{ it.product }}</td>
														<td class="text-center">{{ methodFormatNumber(it.quantity) }}</td>
														<td class="text-right">{{ methodFormatNumber(it.price) }}</td>
														<td class="text-right">{{ methodFormatNumber(it.price * it.quantity) }}</td>
													</tr>
												</tbody>
												<tfoot>
													<tr v-if="item.tithe != null">
														<td colspan="4" class="text-right"><b>Sub Total:</b></td>
														<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
													</tr>
													<tr v-if="item.tithe != null">
														<td colspan="4" class="text-right"><b>Diezmo:</b></td>
														<td class="text-right">{{ methodFormatNumber(item.tithe) }}</td>
													</tr>
													<tr>
														<td colspan="4" class="text-right"><b>TOTAL:</b></td>
														<td class="text-right" v-if="item.tithe != null"><b>{{ methodFormatNumber(totalOrdersLocal(item.total, item.tithe)) }}</b></td>
														<td class="text-right" v-else><b>{{ methodFormatNumber(item.total) }}</b></td>
													</tr>
												</tfoot>
											</table>
											<hr>
											<div class="border rounded border-info" style="padding:10px; margin-bottom:3px">
												<div class="post" v-for="(it, ind) in item.order_observations" :key="ind" style="border: none">
													<div class="user-block" style="border-bottom: 1px solid #ccc">
														<img class="img-circle img-bordered-sm" :src="'/img/perfil/' + it.img" alt="user image">
														<span class="description float-right">{{ it.created_at }}</span>
														<span class="username">
															<a href="#" style="font-size: 12px;">{{ it.user }}</a>
															<span class="float-right btn-tool pointer" v-if="showDeleteOrderObservation(it)" @click="deleteOrderObservationLocal(it)"><i class="fas fa-times"></i></span>
														</span>
														<i href="#" style="font-size: 12px; margin-left:15px">{{ it.observation }}</i>
													</div>
												</div>
												<!-- /.post -->
												<div class="input-group mb-3">
													<input type="text" class="form-control form-control-sm" placeholder="Ingrese comentario" aria-label="Ingrese comentario" aria-describedby="basic-addon2" v-model="observation" @keyup.enter="saveOrderObservationLocal(item)">
													<div class="input-group-append">
														<button class="btn btn-outline-secondary btn-sm" type="button" @click="saveOrderObservationLocal(item)" :disabled="observation.length < 3">Enviar</button>
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-4">
											<div class="tab-pane" id="timeline">
												<!-- The timeline -->
												<div class="timeline timeline-inverse">
													<!-- /.timeline-label -->
													<!-- timeline item -->
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[0].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[0].value }}</span>
															<h3 class="timeline-header"><a>Creado</a></h3>
														</div>
													</div>
													<!-- END timeline item -->
													<!-- timeline item -->
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[1].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[1].value }}</span>
															<h3 class="timeline-header">
																<a href="#" :class="(existsTrackingsOrder[1].value == '----/--/-- --:--') ? 'text-muted' : ''">Confirmado</a>
															</h3>
														</div>
													</div>
													<!-- END timeline item -->
													<!-- timeline item -->
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[3].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[3].value }}</span>
															<h3 class="timeline-header">
																<a href="#" :class="(existsTrackingsOrder[3].value == '----/--/-- --:--') ? 'text-muted' : ''">Atendido</a>
															</h3>
														</div>
													</div>
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[4].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[4].value }}</span>
															<h3 class="timeline-header">
																<a href="#" :class="(existsTrackingsOrder[4].value == '----/--/-- --:--') ? 'text-muted' : ''">Empacado</a>
															</h3>
															<div class="timeline-body text-right" v-if="item.shipping.length == 1 && existsTrackingsOrder[4].value != '----/--/-- --:--'">
																Bultos: <span class="badge badge-secondary">{{ item.shipping[0].packages }}</span> 
																Peso: <span class="badge badge-dark">{{ item.shipping[0].weight }}</span>
															</div>
														</div>
													</div>
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[5].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[5].value }}</span>
															<h3 class="timeline-header">
																<a href="#" :class="(existsTrackingsOrder[5].value == '----/--/-- --:--') ? 'text-muted' : ''">Despachado</a>
															</h3>
															<div class="timeline-body text-right" v-if="item.shipping.length == 1 && existsTrackingsOrder[5].value != '----/--/-- --:--'">
																<span class="badge" :class="'badge-'+getColorTransport(item.shipping[0].transport_id)">{{ item.shipping[0].transport }} 
																	<span v-if="item.shipping[0].freight_order != ''" @dblclick="getInfoShippingCourrier(item.shipping[0])" class="pointer">OF {{ item.shipping[0].freight_order }}</span>
																</span>
															</div>
														</div>
													</div>
													<div>
														<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[6].value != '----/--/-- --:--'"></i>
														<i class="far fa-clock bg-gray" v-else></i>
														<div class="timeline-item">
															<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[6].value }}</span>
															<h3 class="timeline-header">
																<a href="#" :class="(existsTrackingsOrder[6].value == '----/--/-- --:--') ? 'text-muted' : ''">Entregado</a>
															</h3>
														</div>
													</div>
												</div>
											</div>
											<div class="text-right align-bottom">
												<button class="btn btn-secondary btn-sm float-right align-bottom" style="margin: 10px" @click="open = 0">Cerrar</button>
												<button class="btn btn-danger btn-sm float-right align-bottom" style="margin: 10px" @click="deleteOrderLocal(item)" v-if="existsTrackingsOrder[1].value == '----/--/-- --:--'">Eliminar</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<pagination :pagination="paginationOrders" @getAllList="getAllOrdersByTeamLocal"></pagination>
					</div>
					<div class="tab-pane fade" :class="(tabSelected == 2) ? 'show active' : ''"id="tabConsignment" role="tabpanel" aria-labelledby="profile-tab">
						<table class="table table-sm table-hover table-12">
							<thead>
								<tr>
									<th class="text-center">ID</th>
									<th class="text-center">Descripción</th>
									<th class="text-center">Campaña</th>
									<th class="text-center">Total</th>
									<th class="text-center">Estado</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listConsignments" :key="index">
									<td class="text-center">{{ item.id }}</td>
									<td class="text-left">{{ item.description }}</td>
									<td class="text-left">{{ item.team.name }}</td>
									<td class="text-right">{{ methodFormatNumber(sumConsignmentPayment(item.payments)) }}</td>
									<td class="text-center">
										{{ (item.status === null) ? '-' : item.status.name }}
									</td>
									<td class="text-right">
										<i class="fas fa-exclamation-triangle text-warning margin-right5" v-show="analizePaymentsRejectedLocal(item.payments) > 0" :title="'Tiene ' + analizePaymentsRejectedLocal(item.payments) + ' pago(s) rechazado(s)'"></i>
										<i class="pointer far fa-eye text-info" @click="showConsignmentModalComponentLocal(item.id)"></i>
									</td>
								</tr>
							</tbody>
						</table>
						<pagination :pagination="paginationConsignments" @getAllList="getAllConsignmentsByTeamLocal"></pagination>
	
					</div>
				</div>
			</div>
			<div class="alert alert-danger" role="alert" v-else>
				{{ messageError }}
				<router-link to="/teams" title="Volver a Campañas" class="float-right">
					Volver a Campañas
				</router-link>
			</div>
		</div>
		<div class="alert alert-info" role="alert" v-else>
			Buscando Campaña Nº {{ idLocal }}
			<div class="spinner-border square-20 float-right" role="status">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>

		<order-colportaje-modal-component ref="orderColportajeModalComponent"
            :teamId="idLocal"
			:teamName="teamName"
			@saveOrderComponent="saveOrderLocal">
        </order-colportaje-modal-component>


		<div class="modal" tabindex="-1" id="consignmentModal">
			<div class="modal-dialog">
				<div class="modal-content modal-content-consignment">
					<div class="form-group">
						<div>
							<label for="consignmentSelect">Seleccione la remesa {{objectConsignment.id}}</label>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="btnCloseConsignmentModal">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<select class="form-control form-control-sm" id="consignmentSelect" v-model="objectConsignment.id" :disabled="disabledSelectConsignment">
							<option value="-1" disabled>Seleccione una remesa de la lista</option>
							<option v-for="(item, index) in objectTeam.consignments" :key="index" :value="item.id">
								{{ item.description }}
							</option>
							<option value="0">
								Crear nueva remesa
							</option>
						</select>
					</div>
					<div class="form-group" v-show="objectConsignment.id == 0">
						<label for="newDescriptionConsignmentInput">Nombre de la nueva remesa</label>
						<input type="text" class="form-control form-control-sm" v-model="objectConsignment.description"/>
					</div>
					<hr>
					<div class="text-right">
						<button class="btn btn-sm btn-primary" :disabled="disabledBtnNextConsignment" @click="actionBtnNextConsignment()">Siguiente</button>
					</div>
				</div>
			</div>
		</div>

		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#consignmentModal" ref="btnShowConsignmentModal" v-show="false">
  			Abrir Remesas
		</button>

		<payment-modal-component v-show="objectConsignment.exists > 0" ref="paymentModalComponent" controller="consignment"
			:id="objectConsignment.id" :title="' - Remesa ' + objectConsignment.description + ' - '"
			:modal="true"
			@addRow="addRowPayment"
			@removeRow="removeRowPayment"
			@uploadDocument="showUploadDocumentModalComponentLocal">
		</payment-modal-component>

		<upload-document-modal-component ref="uploadDocumentModalComponent" controller="payment" configUploadDocumentId="2" :id="paymentId" :btnDelete="true" :btnUpload="true"></upload-document-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import team from '@/mixins/teams'
import order from '@/mixins/orders'
import consignment from '@/mixins/consignments'
import payment from '@/mixins/generals/payment.js'

import Pagination from '@/components/Pagination.vue'
import OrderColportajeModalComponent from '@/components/OrderColportajeModalComponent.vue'
import PaymentModalComponent from '@/components/PaymentModalComponent.vue'
import UploadDocumentModalComponent from '@/components/UploadDocumentModalComponent.vue'

export default {
	name: 'Team',
	mixins: [axiosAction, errors, mixin, team, order, consignment, payment],
	props: ['id'],
	data() {
		return {
			idLocal: this.id,
			teamName: '',
			loadingTeam: false,
			messageError: '',
			disabledSelectConsignment: false,
			paymentId: 0,
			tabSelected: 1,
			open: -1,
			trackingsOrder: [
                { id: 1, value: '----/--/-- --:--', user: '' },
                { id: 2, value: '----/--/-- --:--', user: '' },
                { id: 3, value: '----/--/-- --:--', user: '' },
                { id: 4, value: '----/--/-- --:--', user: '' },
                { id: 5, value: '----/--/-- --:--', user: '' },
                { id: 6, value: '----/--/-- --:--', user: '' },
                { id: 7, value: '----/--/-- --:--', user: '' },
                { id: 8, value: '----/--/-- --:--', user: '' },
            ],
            dataConfirm: {
                transportId: 0,
                ctacteId: 0,
                typeLegalDocumentId: 0,
                typeLegalDocument52: 1
            },
            fecmov: '',
            succod: '',
            codbareti: '',
            tipocompcod: 20,
            nrocomp: ''
		}
	},
	computed: {
        existsTrackingsOrder() {
            if(this.open > 0) {
                let length = this.trackingsOrder.length
                for(let i=0;i<length;i++) {
                    let index = this.listOrders[this.open -1].order_tracking_order.map((el) => parseInt(el.trackings_order_id)).indexOf(parseInt(this.trackingsOrder[i].id))
                    if(index > -1) {
                        this.trackingsOrder[i].value = this.listOrders[this.open -1].order_tracking_order[index].created
                        this.trackingsOrder[i].valuserue = this.listOrders[this.open -1].order_tracking_order[index].user
                    } else {
                        this.trackingsOrder[i].value = '----/--/-- --:--'
                        this.trackingsOrder[i].user = ''
                    }
                }
            }
            return this.trackingsOrder
        },
		totalOrdersPrice() {
			let total = this.objectTeam.orders.reduce(function(a, b) { 
							return a + b.total
						}, 0);
			return total.toFixed(0)
		},
		totalConsignmentsPrice() {
			let total = this.objectTeam.consignments.reduce(function(a, b) { 
							return a + b.total
						}, 0);
			return total.toFixed(0)
		},
		disabledBtnNextConsignment() {
			if(this.objectConsignment.id > 0 || (this.objectConsignment.id == 0 && this.objectConsignment.description.trim().length > 2)) {
				return false
			}
			return true
		},
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Campaña Nº ' + this.idLocal)
			this.setSubTitleModule('')
			this.showTeamLocal()
		},
		addRowPayment(id, data) {
			let index = this.objectTeam.consignments.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1) {
				this.objectTeam.consignments[index].payments.push(data.payment)
			}
		},
		deleteOrderLocal(item) {
			if(confirm('Esta a punto de borrar el pedido de "' + item.client + ' (' + item.id + ')"\n¿Quiere continuar?')) {
				this.deleteOrder(item.id)
			}
        },
        deleteOrderResultLocal(response) {
            this.open = 0
        },
		deleteOrderObservationLocal(it) {
            this.deleteOrderObservation(it.order_id, it.id)
        },
		getAllConsignmentsByTeamLocal(page) {
			this.getAllConsignmentsByTeam(page, this.idLocal)
		},
		getAllOrdersByTeamLocal(page) {
			this.getAllOrdersByTeam(page, this.idLocal)
		},
		getAllOrdersResultLocal(response) {
		},
		getAllComunasResultLocal(response) {
		},
		getAllConsignmentsResultLocal (response) {
		},
		removeRowPayment(id, data) {
		},
        saveOrderObservationLocal(item) {
            if(this.observation.length > 2) {
                this.saveOrderObservation(item.id)
            }
        },
		showConsignmentModalComponentLocal(id) {
			this.id = id
			if(this.id == 0) {
				this.clearObjectConsignment()
				this.$refs.btnConsignmentModal.click()
			} else if(this.id > 0) {
				this.showConsignment(this.id)
			}
		},
		showUploadDocumentModalComponentLocal(id, idPayment) {
			this.paymentId = id
			setTimeout(() => {
				this.$refs.uploadDocumentModalComponent.$refs.btnGetUploadDocument.click()
				this.$refs.uploadDocumentModalComponent.$refs.showUploadDocument.click()
			}, 10)
		},
		actionBtnNextConsignment(){
			if(this.objectConsignment.id == 0) {
				this.objectConsignment.team_id = this.idLocal
				this.objectConsignment.exists = 0
				this.saveConsignment()
			} else {
				this.showConsignment(this.objectConsignment.id)
			}
		},
		saveConsignmentResultLocal(response) {
			if(response.data.success === true) {
				this.objectTeam.consignments.push(response.data.data)
				this.objectConsignment.id = response.data.data.id
				this.actionBtnNextConsignment()
			}
		},
		selectTab(index) {
			this.tabSelected = index
			switch(index) {
				case 1:
					this.getAllOrdersByTeamLocal(1)
					break
				case 2:
					this.getAllConsignmentsByTeamLocal(1)
					break
			}
		},
	    showDataToConfirmModal(id) {
            if(this.auth.role_id != 9 && this.auth.role_id != 10){
                this.showOrder(id)
            } else {
                console.log('no tiene permiso para esto')
            }
        },
        showOrderResultLocal(response) {
            this.btnCloseDataToConfirmModal()
            this.setObjectOrder(response.data.data)
            this.dataConfirm.ctacteId = (this.objectOrder.total < this.valueCtacte) ? 0 : 1
            this.$refs.btnDataToConfirmModal.click()
        },
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'deleteOrderResult': this.deleteOrderResult(response); break;
				case 'deleteOrderObservationResult': this.deleteOrderObservationResult(response); break;
				case 'getAllConsignmentsResult': this.getAllConsignmentsResult(response); break;
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				case 'showOrderResult': this.showOrderResult(response); break;
				case 'showConsignmentResult': this.showConsignmentResult(response); break;
				case 'showTeamResult': this.showTeamResult(response); break;
				case 'saveConsignmentResult': this.saveConsignmentResult(response); break;
				case 'saveOrderObservationResult': this.saveOrderObservationResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveOrderLocal(order) {
			this.objectTeam.orders.push(order)
			this.addListOrders(order)
		},
		showConsignmentResultLocal(response) {
			this.$refs.btnCloseConsignmentModal.click()
			this.$refs.paymentModalComponent.$refs.showPayment.click()
			console.log(this.objectConsignment.id)
		},
		showConsignmentModalLocal() {
			this.disabledSelectConsignment = false
			this.objectConsignment.id = -1
			this.$refs.btnShowConsignmentModal.click()
		},
        showDeleteOrderObservation(item) {
            return this.auth.id == item.user_id
        },
		showTeamLocal() {
			this.loadingTeam = true
			this.showTeamFull(this.idLocal)
		},
		showTeamResultLocal(response) {
			this.loadingTeam = false
			if(response.data.success !== true) {
				this.messageError = response.data.data
				this.$snotify.error(response.data.data, response.data.message)
			} else {
				this.setTitleModule('Campaña ' + this.objectTeam.name)
				this.teamName = this.objectTeam.name
			}
		},
		showOrderColportajeModalComponentLocal() {
			this.$refs.orderColportajeModalComponent.$refs.btnShowOrderColportajeModalComponent.click()
		},
		totalOrdersLocal(total, tithe) {
            return parseInt(Math.round(parseFloat(total) + parseFloat(tithe)))
        }
	},
	components: {
		'pagination': Pagination,
		'order-colportaje-modal-component': OrderColportajeModalComponent,
		'payment-modal-component': PaymentModalComponent,
		'upload-document-modal-component': UploadDocumentModalComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
	.modal-content-consignment {
		padding: 10px;
	}
</style>